
import { Component, Vue, Prop } from "vue-property-decorator"
import { Getter } from "vuex-class"

import ViewFolderItem from "./ViewFolderItem.vue"
import { UserSettings } from "@/types/userSettings"

import { sortBy } from "lodash"
import { ViewSummary } from "@/types/views/viewSummary"
import { InsightSummary } from "@/types/insights"

@Component({
	components: {
		"case-filter-item": ViewFolderItem
	}
})
export default class ViewFolders extends Vue {
	@Prop()
	views!: (ViewSummary | InsightSummary)[] ;

	@Prop()
	activeViewId!: string | null;

	@Getter("getUserSettings")
	public userSettings!: UserSettings;

	public get folders () {
		const folders: { [key: string]: (ViewSummary | InsightSummary)[]} = {}

		// Sort by folder then title, so folders are alphabetical and then titles are alphabetical too
		const sorted = sortBy(this.views, ["folder", "title"])
		sorted.forEach(view => {
			if (view.folder && view.folder !== "") {
				if (folders[view.folder]) {
					folders[view.folder].push(view)
				} else {
					folders[view.folder] = [view]
				}
			}
		})

		return folders
	}

	public get groupedViews () {
		return this.views.filter(v => v.folder && v.folder !== "")
	}

	public get ungroupedViews () {
		return this.views.filter(v => !v.folder || v.folder === "")
	}

	public getView (viewId: string) {
		return this.views.find(v => v.id === viewId)
	}

	public getCaseCount (view: ViewSummary | InsightSummary): number | null {
		if (view && "caseCount" in view) {
			return view["caseCount"]
		}
		return null
	}

	public goToView (viewId: string) {
		this.$emit("gotoPage", viewId)

		this.$emit("selectInsight", this.getView(viewId))
	}

	public get expandedByDefault () {
		if (this.userSettings && this.userSettings.settings && this.userSettings.settings.viewFoldersExpanded !== null) {
			return this.userSettings.settings.viewFoldersExpanded
		}
		return true
	}
}
